'use client';

import { useRef } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { Sparkles, Float } from '@react-three/drei';

const AnimatedSparkles = () => {
    return (
        <group>
            <Float speed={1} rotationIntensity={0.5} floatIntensity={0.5}>
                <Sparkles
                    count={200}
                    scale={10}
                    size={3}
                    speed={0.4}
                    opacity={0.4}
                    color="#4f46e5"
                />
            </Float>
            <Float speed={1.5} rotationIntensity={1} floatIntensity={0.2}>
                <Sparkles
                    count={150}
                    scale={15}
                    size={2}
                    speed={0.3}
                    opacity={0.3}
                    color="#818cf8"
                />
            </Float>
        </group>
    );
};

const ServicesBackground = () => {
    return (
        <div className="fixed inset-0 z-[-1] pointer-events-none">
            {/* Gradient Backup */}
            <div className="absolute inset-0 bg-gradient-to-b from-slate-50 via-white to-slate-50/80" />

            {/* R3F Canvas */}
            <div className="absolute inset-0 opacity-60">
                <Canvas camera={{ position: [0, 0, 5] }} dpr={[1, 2]}>
                    <AnimatedSparkles />
                </Canvas>
            </div>
        </div>
    );
};

export default ServicesBackground;
